export default {
  document: {
    title: "Supprimer le document",
    description: "Cliquez sur supprimer pour supprimer ce document.",
  },
  "hardware-equipment-item": {
    title: "Supprimer l'élément",
    description:
      "Êtes-vous sûr de vouloir supprimer cet élément de votre matériel ?",
  },
  title: "Supprimer l'élément",
  description: "Êtes-vous sûr de vouloir supprimer cet élément ?",
}
